import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../static/img/illustrations/Folder.svg'


const _withScopeId = n => (_pushScopeId("data-v-c230d74a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "row q-gutter-y-sm justify-center q-my-md" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  key: 0,
  class: "q-pt-lg"
}
const _hoisted_7 = { class: "justified-center" }
const _hoisted_8 = { class: "q-mt-sm q-mb-sm" }
const _hoisted_9 = { class: "row q-gutter-y-sm justify-center q-mb-md" }
const _hoisted_10 = { class: "q-pa-md" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "ellipsis" }
const _hoisted_15 = {
  key: 0,
  alt: "",
  class: "q-mb-md",
  src: _imports_0
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "ellipsis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_step = _resolveComponent("q-step")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_brief_item = _resolveComponent("brief-item")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_file_uploader = _resolveComponent("file-uploader")!
  const _component_file_report = _resolveComponent("file-report")!
  const _component_q_stepper = _resolveComponent("q-stepper")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    title: _ctx.t('IMPORT_TITLE', { leads: _ctx.t('LEAD.LOW.PLUR') }),
    "confirm-label": _ctx.confirmLabel,
    "disable-confirm": _ctx.disableConfirm,
    onConfirm: _ctx.confirm,
    "cancel-label": _ctx.step !== 0 ? _ctx.t('ACTION.BACK') : _ctx.t('ACTION.CANCEL'),
    "disable-cancel": _ctx.step === 3 && _ctx.steps[3].done,
    onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.step !== 0 ? _ctx.back() : _ctx.closeImportDialog())),
    "secondary-label": _ctx.step === 2 ? _ctx.t('STEP_1.BTN_INSTRUCTIONS') : null,
    onSecondary: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openInstructions(_ctx.selectedAssetCategory))),
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, {
        flat: "",
        id: "iap-import-stepper",
        ref: "iapImportStepper"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-pa-none" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_stepper, {
                animated: "",
                flat: "",
                "header-class": "hidden",
                ref: "stepper",
                modelValue: _ctx.step,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_step, {
                    done: _ctx.steps[0].done,
                    name: 0,
                    title: "",
                    class: "q-px-lg",
                    prefix: "0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _mergeProps({ class: "q-pt-lg" }, _ctx.TEXT_QUATERNARY_TITLE), _toDisplayString(_ctx.t('STEP_0.TITLE_SELECT_SOURCE')), 17),
                          _createElementVNode("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetCategories, (category) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_q_radio, _mergeProps({
                                class: [{ active: category.value === _ctx.selectedAssetCategory }, "iuf-radio"],
                                key: category.value,
                                val: category.value
                              }, _ctx.RADIO_PROPS, {
                                modelValue: _ctx.selectedAssetCategory,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAssetCategory) = $event))
                              }), {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_q_btn, _mergeProps({
                                      label: _ctx.t('STEP_1.BTN_INSTRUCTIONS'),
                                      class: "float-right"
                                    }, _ctx.BTN_SECONDARY_MD, {
                                      onClick: _withModifiers(($event: any) => (_ctx.openInstructions(category.value)), ["stop","prevent"])
                                    }), null, 16, ["label", "onClick"]),
                                    _createVNode(_component_q_icon, {
                                      name: category.icon
                                    }, null, 8, ["name"]),
                                    _createElementVNode("span", null, _toDisplayString(category.label), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1040, ["class", "val", "modelValue"])), [
                                [_vShow, !category.admin || _ctx.isTechnicalAdmin]
                              ])
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["done"]),
                  _createVNode(_component_q_step, {
                    done: _ctx.steps[1].done,
                    name: 1,
                    title: "",
                    class: "q-px-lg",
                    prefix: "1"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _mergeProps({ class: "q-pt-lg" }, _ctx.TEXT_QUATERNARY_TITLE), _toDisplayString(_ctx.t('STEP_1.TITLE_SELECT_BRIEF', { brief: _ctx.t('BRIEF.LOW.SING') })), 17),
                          _createElementVNode("div", _mergeProps(_ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-lg" }), _toDisplayString(_ctx.t('TYPE')), 17),
                          _createElementVNode("div", _mergeProps(_ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
                            _createVNode(_component_q_icon, _mergeProps({
                              name: _ctx.getAssetCategory(_ctx.selectedAssetCategory).icon,
                              class: "q-mr-xs"
                            }, _ctx.ICON_PROPS.BTN_LG), null, 16, ["name"]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.getAssetCategory(_ctx.selectedAssetCategory).label), 1)
                          ], 16),
                          (_ctx.preSelectedBrief)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(_component_q_item_label, _mergeProps({ class: "q-mb-sm" }, _ctx.TEXT_CARD_BODY), {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('CURRENT_BRIEF', { brief: _ctx.t('BRIEF.LOW.SING') })), 1)
                                  ]),
                                  _: 1
                                }, 16),
                                _createElementVNode("div", _hoisted_7, [
                                  _createVNode(_component_brief_item, {
                                    brief: _ctx.preSelectedBrief,
                                    "selected-brief": _ctx.selectedBrief,
                                    onSelectedBrief: _ctx.selectBrief
                                  }, null, 8, ["brief", "selected-brief", "onSelectedBrief"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_q_toolbar, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_input, _mergeProps({
                                label: _ctx.t('BRIEF_NAME', { Brief: _ctx.t('BRIEF.CAP.SING') }),
                                placeholder: _ctx.t('SEARCH_BRIEF_PLACEHOLDER', { brief: _ctx.t('BRIEF.LOW.SING') }),
                                autofocus: "",
                                class: "full-width",
                                maxlength: _ctx.MAX_LENGTH.BRIEF.NAME
                              }, _ctx.INPUT_LG, {
                                modelValue: _ctx.searchText,
                                "onUpdate:modelValue": [
                                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchText) = $event)),
                                  _ctx.getSuggestedBriefs
                                ]
                              }), {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: _ctx.ICONS_NAME.SEARCH_OUTLINE
                                  }, null, 8, ["name"])
                                ]),
                                _: 1
                              }, 16, ["label", "placeholder", "maxlength", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_q_item_label, _normalizeProps(_guardReactiveProps(_ctx.TEXT_CARD_BODY)), {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.searchText.length > 0
                                                    ? _ctx.t('MATCHED_BRIEFS', { briefs: _ctx.t('BRIEF.LOW.PLUR') })
                                                    : _ctx.t('MY_BRIEFS', { briefs: _ctx.t('BRIEF.LOW.PLUR') })), 1)
                              ]),
                              _: 1
                            }, 16)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            (!_ctx.myBriefList || !_ctx.myBriefList.length)
                              ? (_openBlock(), _createBlock(_component_q_item, {
                                  key: 0,
                                  class: "q-px-sm"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, {
                                          class: "text-caption",
                                          lines: "1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('NOT_FOUND', { brief: _ctx.t('BRIEF.LOW.PLUR') })), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myBriefList, (brief) => {
                              return (_openBlock(), _createBlock(_component_brief_item, {
                                brief: brief,
                                key: brief.dobjId,
                                "selected-brief": _ctx.selectedBrief,
                                onSelectedBrief: _ctx.selectBrief
                              }, null, 8, ["brief", "selected-brief", "onSelectedBrief"]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["done"]),
                  _createVNode(_component_q_step, {
                    done: _ctx.steps[2].done,
                    error: _ctx.steps[2].error,
                    name: 2,
                    title: "",
                    class: "q-px-lg",
                    prefix: "2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_q_inner_loading, {
                          showing: _ctx.steps[2].loading
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_spinner, {
                              color: "primary",
                              size: "5em"
                            }),
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('STEP_2.LOADING_FILES_MSG')), 1)
                          ]),
                          _: 1
                        }, 8, ["showing"]),
                        (!_ctx.steps[2].loading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _mergeProps({ class: "q-pt-lg" }, _ctx.TEXT_QUATERNARY_TITLE), _toDisplayString(_ctx.t('STEP_2.TITLE_UPLOAD')), 17),
                                  _createElementVNode("div", _mergeProps(_ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-lg" }), _toDisplayString(_ctx.t('TYPE')), 17),
                                  _createElementVNode("div", _mergeProps(_ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
                                    _createVNode(_component_q_icon, _mergeProps({
                                      name: _ctx.getAssetCategory(_ctx.selectedAssetCategory).icon,
                                      class: "q-mr-xs"
                                    }, _ctx.ICON_PROPS.BTN_LG), null, 16, ["name"]),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getAssetCategory(_ctx.selectedAssetCategory).label), 1)
                                  ], 16),
                                  _createElementVNode("div", _mergeProps(_ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-lg" }), _toDisplayString(`${_ctx.t('DEFAULT')} ${_ctx.t('BRIEF.LOW.SING')}`), 17),
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_q_avatar, {
                                      color: _ctx.getColorName(_ctx.selectedBrief.style),
                                      class: "text-uppercase q-mr-xs",
                                      rounded: "",
                                      size: "20px",
                                      "text-color": "white"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.selectedBrief.name.charAt(0)), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color"]),
                                    _createElementVNode("span", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), _toDisplayString(_ctx.selectedBrief.name), 17)
                                  ]),
                                  _createVNode(_component_file_uploader, {
                                    "browse-btn": "",
                                    class: "q-my-lg lead-import-file-uploader",
                                    accept: _ctx.steps[2].formats.join(', '),
                                    label: _ctx.t('STEP_2.UPLOADER.LABEL_MSG'),
                                    onUpload: _ctx.handleUpload,
                                    ref: "uploader"
                                  }, {
                                    image: _withCtx(() => [
                                      (!_ctx.steps[2].files.length)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["accept", "label", "onUpload"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["done", "error"]),
                  _createVNode(_component_q_step, {
                    done: _ctx.steps[3].done,
                    error: _ctx.steps[3].error,
                    name: 3,
                    class: "q-pa-lg",
                    title: "",
                    prefix: "3"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _normalizeProps(_guardReactiveProps(_ctx.TEXT_QUATERNARY_TITLE)), _toDisplayString(_ctx.steps[3].done ? _ctx.t('STEP_3.TITLE_IMPORTED') : _ctx.t('STEP_3.TITLE_FILE_ANALYSIS')), 17),
                          _createElementVNode("div", _mergeProps(_ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-lg" }), _toDisplayString(_ctx.t('TYPE')), 17),
                          _createElementVNode("div", _mergeProps(_ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
                            _createVNode(_component_q_icon, _mergeProps({
                              name: _ctx.getAssetCategory(_ctx.selectedAssetCategory).icon,
                              class: "q-mr-xs"
                            }, _ctx.ICON_PROPS.BTN_LG), null, 16, ["name"]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.getAssetCategory(_ctx.selectedAssetCategory).label), 1)
                          ], 16),
                          _createElementVNode("div", _mergeProps(_ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-lg" }), _toDisplayString(`${_ctx.t('DEFAULT')} ${_ctx.t('BRIEF.CAP.SING')}`), 17),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_q_avatar, {
                              color: _ctx.getColorName(_ctx.selectedBrief.style),
                              class: "text-uppercase q-mr-xs",
                              rounded: "",
                              size: "20px",
                              "text-color": "white"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.selectedBrief.name.charAt(0)), 1)
                              ]),
                              _: 1
                            }, 8, ["color"]),
                            _createElementVNode("span", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), _toDisplayString(_ctx.selectedBrief.name), 17)
                          ]),
                          _createVNode(_component_file_report, {
                            "current-step-loading": _ctx.steps[3].loading,
                            done: _ctx.steps[3].done,
                            "errors-contains-warning": _ctx.errorsContainsWarning,
                            "file-uploaded": _ctx.steps[2].files[0],
                            files: _ctx.steps[2].files[0],
                            "list-to-import": _ctx.listToImport || [],
                            "previous-step-loading": _ctx.steps[2].loading,
                            summary: _ctx.errorsListInParsing || [],
                            onNotImportable: _ctx.updateConfirmState
                          }, null, 8, ["current-step-loading", "done", "errors-contains-warning", "file-uploaded", "files", "list-to-import", "previous-step-loading", "summary", "onNotImportable"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["done", "error"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "confirm-label", "disable-confirm", "onConfirm", "cancel-label", "disable-cancel", "secondary-label"]))
}